// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1W8NU","info":"PatientInfo_info__fXbEQ"};